import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EllipsisOutlinedSvg from "@ant-design/icons-svg/es/asn/EllipsisOutlined";
import AntdIcon from "../components/AntdIcon";
var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EllipsisOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EllipsisOutlined.displayName = 'EllipsisOutlined';
}
export default /*#__PURE__*/React.forwardRef(EllipsisOutlined);